export const Staging = 'https://securegw-stage.paytm.in'
export const Production = 'https://securegw.paytm.in'